import React, { HTMLAttributes } from "react";

import classnames from "classnames";

import { StyledDialogContentDivider } from "./Styles";
// import { useDialogContext } from "./DialogContext";

export const DialogContentDivider = ({
  className,
}: HTMLAttributes<HTMLDivElement>) => {
  // useDialogContext();

  return (
    <StyledDialogContentDivider
      className={classnames("c-dialog-content-divider", className)}
    />
  );
};

DialogContentDivider.displayName = "DialogContentDivider";
